import { createRoot } from 'react-dom/client';
import { App } from 'features';
// Providers
import { QueryClientProvider } from '@tanstack/react-query';
import { PymProvider } from '@telescope/cassini-hooks';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from 'lib';

const container = document.getElementById('root');

if (!container) throw new Error ('Root element not found');

const root = createRoot(container);

root.render(
  <PymProvider>
    <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools />
      <App />
    </QueryClientProvider>
  </PymProvider>);
